<template>
  <div :class="style.heading">
    <InputStyle
      description="Заголовок"
      placeholder="Введите заголовок"
      size="M"
      :modelValue="actionHeaderContacts"
      @update:modelValue="updateActionHeaderContacts"
    />
  </div>
</template>

<script lang="ts">
import {defineComponent} from "vue";
import style from "./ActionContactsSettingComponent.module.scss";
import {modifyQuiz} from "@/page/quiz/scriptQuiz";
import {questions, Quiz} from "@/page/quiz/typeQuiz";
import InputStyle from "@/elements/UI/input/Style/InputStyle.vue";

export default defineComponent({
  name: "ActionContactsSettingComponent",

  components: {
    InputStyle
  },

  data() {
    return {
      style,
      modifyQuiz
    };
  },

  methods: {
    updateActionHeaderContacts(value: string): void {
      // this.modifyQuiz("set", value, ["actionHeader"]);
      // if (!this.contactsQuestion?.headerActionMobile) {
      //   this.contactsQuestion.headerActionMobile = {
      //     placeholder: value
      //   };
      // }
      // this.contactsQuestion.headerActionMobile.placeholder = value;

      this.modifyQuiz("set", value, [
        "questions",
        this.selectedQuestion,
        "contacts",
        "headerActionMobile",
        "placeholder"
      ]);
    }
  },

  computed: {
    quiz(): Quiz {
      return this.$quizStore.getQuiz;
    },

    mobileVersion(): boolean {
      return this.$quizStore.getSelectedVersion === "Мобильная";
    },

    selectedQuestion(): number {
      return this.$quizStore.getSelectedQuestion;
    },

    currentQuestion(): questions {
      return this.quiz.questions[this.selectedQuestion];
    },

    contactsQuestion() {
      return this.currentQuestion?.contacts;
    },

    actionHeaderContacts(): string {
      return (
        this.modifyQuiz("get", "", [
          "questions",
          this.selectedQuestion,
          "contacts",
          "headerActionMobile",
          "placeholder"
        ]) ?? ""
      );
    }
  }
});
</script>
